// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time. See https://www.notion.so/BP-Date-Time-2ef8643321f48032ad80e8a5b30aa278 for more information
import { format } from "date-fns";

export const CALENDAR_CELL_ID_FORMAT = "yyyy-MM-dd";

export function getIdByDate(date: Date): string {
  return format(date, CALENDAR_CELL_ID_FORMAT);
}
